import * as React from 'react';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

import loaderShort from '../../img/loading_short.gif';
import loaderLong from '../../img/loading_long.gif';
import { isSomeApiFetchingSelector } from '../../state/axiosInterceptor/axiosInterceptor.selectors';

type Props = {
  type?: keyof typeof loaders;
  className?: string;
  isAlwaysShown?: boolean;
};

const loaders = {
  shortProcess: loaderShort,
  longProcess: loaderLong
};

const useStyles = makeStyles(() =>
  createStyles({
    spinnerOverlay: {
      position: 'fixed',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
    }
  }),
);

const Loading = ({ type = 'shortProcess', className, isAlwaysShown }: Props ) => {
  const classes = useStyles();
  const isSomeApiFetching = useSelector(isSomeApiFetchingSelector);

  return (
    isSomeApiFetching || isAlwaysShown ? (
      <>
        <Box className={classes.spinnerOverlay} />
        <Box
          display="flex"
          flex="1 1 auto"
          justifyContent="center"
          alignItems="center"
          padding={3}
          className={clsx(className)}
        >
          <img src={loaders[type]} alt="loader" style={{ maxHeight: '100%' }}/>
        </Box>
      </>
    ) : null
  );
};

export default Loading;
